/**
 * Contact Form Fields.
 * @format
 */

export const reimbursmentFormFields = [
  {
    fieldTitle: 'First name',
    fieldName: 'FirstName',
    id: 'first-name',
    type: 'text',
    placeholderText: 'Your first name here',
    errorMessage: 'First name field required.',
    required: true,
    list: null,
    useNameAsLookupValue: false,
  },
  {
    fieldTitle: 'Last name',
    fieldName: 'LastName',
    id: 'last-name',
    type: 'text',
    placeholderText: 'Your last name here',
    errorMessage: 'Last name field required.',
    required: true,
    list: null,
    useNameAsLookupValue: false,
  },
  {
    fieldTitle: 'Email address',
    fieldName: 'Email',
    id: 'email',
    type: 'email',
    placeholderText: 'name@website.com',
    errorMessage: 'Invalid email.',
    required: true,
    list: null,
    useNameAsLookupValue: false,
  },
  {
    fieldTitle: 'Organization',
    fieldName: 'Organization',
    id: 'organization',
    type: 'text',
    placeholderText: "Your organization's name",
    errorMessage: 'Organization field required.',
    required: true,
    list: null,
    useNameAsLookupValue: false,
  },
  {
    fieldTitle: 'Medical Specialty',
    fieldName: 'MedicalSpecialty',
    id: 'medical-specialty',
    type: 'text',
    placeholderText: 'Your medical specialty',
    errorMessage: 'Medical specialty field required.',
    required: true,
    list: null,
    useNameAsLookupValue: false,
  },
  {
    fieldTitle: 'Subject',
    fieldName: 'Subject',
    id: 'subject',
    type: 'text',
    placeholderText: 'Subject',
    errorMessage: 'Subject field required.',
    required: true,
    list: null,
    useNameAsLookupValue: false,
  },
  {
    fieldTitle: 'Message',
    fieldName: 'mktoCommentCapture',
    id: 'comment',
    type: 'textarea',
    placeholderText: '',
    errorMessage: 'Reason for contact is required.',
    required: true,
    list: null,
    useNameAsLookupValue: false,
  },
];
